import { useTranslation } from 'react-i18next'

import InfoBeket from 'shared/images/info.webp'
import { Button } from 'shared/ui/button'

import styles from './styles.module.scss'

interface Props {
  onContinue: (isForMySelf?: boolean) => void
}

const PopUp = ({ onContinue }: Props) => {
  const { t } = useTranslation()

  const btnStyle = {
    borderRadius: '16px',
    fontWeight: 600,
    fontSize: 17,
  }

  return (
    <div className={styles.container}>
      <img
        alt=""
        src={InfoBeket}
        className={styles.icon}
      />

      <p className={styles.title}>{t('clarify')}</p>
      <p className={styles.titleDesc}>{t('clarify_desc')}</p>

      <div className={styles.buttons}>
        <div className={styles.button}>
          <Button
            style={btnStyle}
            onClick={() => onContinue(true)}
          >
            {t('my_self')}
          </Button>
        </div>
        <div className={styles.button}>
          <Button
            style={btnStyle}
            variant="transparentBlue"
            onClick={() => onContinue(false)}
          >
            {t('for_other')}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default PopUp
